module.exports = __webpack_public_path__ + "img/bottom_on.fb0d1309.png";